module.exports = __webpack_public_path__ + "img/red-info-alert.c1801fe0.svg";